import { render } from "./Stats.vue?vue&type=template&id=6605372e&scoped=true"
import script from "./Stats.vue?vue&type=script&lang=js"
export * from "./Stats.vue?vue&type=script&lang=js"

import "./Stats.vue?vue&type=style&index=0&id=6605372e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6605372e"

export default script